(function () {
  function getDrawer() {
    return document.querySelector("#inventoryDrawerContent");
  }

  function extractAddressFromCard(card) {
    const name =
      card.querySelector(".location-card-drawer-list-view-name")?.textContent?.trim() || "";
    const addr =
      card.querySelector(".location-card-drawer-list-view-address")?.innerText?.trim() || "";

    // Combine + clean whitespace into one line
    return (name + "\n" + addr).replace(/\s+/g, " ").trim();
  }

  function makeMapSrcFromAddress(address) {
    return `https://www.google.com/maps?q=${encodeURIComponent(address)}&z=14&output=embed`;
  }

  function setDrawerTitle(drawer) {
    const title = drawer.querySelector("#inventoryDrawerTitle");
    if (title) title.textContent = "Our Locations";
  }

  function injectMapsIntoAllCards(drawer) {
    const cards = drawer.querySelectorAll(".locationCardDrawerView");
    if (!cards.length) return;

    cards.forEach((card) => {
      if (card.dataset.mapInjected === "1") return;

      const address = extractAddressFromCard(card);
      if (!address) return;

      const mapWrap = document.createElement("div");
      mapWrap.className = "multiloca-card-map";

      const iframe = document.createElement("iframe");
      iframe.className = "multiloca-card-map-iframe";
      iframe.title = "Store map";
      iframe.loading = "lazy";
      iframe.referrerPolicy = "no-referrer-when-downgrade";
      iframe.src = makeMapSrcFromAddress(address);

      mapWrap.appendChild(iframe);

      // Place map near the bottom of the card (before directions link if possible)
      const directions = card.querySelector(".location-card-drawer-list-view-direction");
      if (directions && directions.parentNode) {
        directions.parentNode.insertBefore(mapWrap, directions);
      } else {
        card.appendChild(mapWrap);
      }

      card.dataset.mapInjected = "1";
    });
  }

  function initIfOpen() {
    const drawer = getDrawer();
    if (!drawer) return;

    setDrawerTitle(drawer);
    injectMapsIntoAllCards(drawer);
  }

  // The drawer is created dynamically by the app, so we trigger init after clicks
  document.addEventListener("click", function () {
    setTimeout(initIfOpen, 50);
    setTimeout(initIfOpen, 250);
    setTimeout(initIfOpen, 600);
  });

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(initIfOpen, 250);
  });
})();

(function forceLocateStoreLabel() {
  const LABEL = "Locate a store";

  function setLabel() {
    const el = document.querySelector("#location-popup-header-id");
    if (el && el.textContent.trim() !== LABEL) {
      el.textContent = LABEL;
    }
  }

  // Run on load + after clicks (app updates this on selection)
  document.addEventListener("DOMContentLoaded", () => {
    setLabel();
    setTimeout(setLabel, 300);
    setTimeout(setLabel, 1000);
  });

  document.addEventListener("click", () => {
    setTimeout(setLabel, 50);
    setTimeout(setLabel, 250);
    setTimeout(setLabel, 600);
  });

  // Light observer only for that element
  const obs = new MutationObserver(setLabel);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

(function stripEmptyMultilocationHeading() {
  function removeEmptyHeading() {
    document
      .querySelectorAll(".multilocation-header__title")
      .forEach((h4) => {
        if (!h4.textContent.trim()) {
          h4.remove();
        }
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    removeEmptyHeading();
    setTimeout(removeEmptyHeading, 300);
    setTimeout(removeEmptyHeading, 1000);
  });

  document.addEventListener("click", () => {
    setTimeout(removeEmptyHeading, 50);
    setTimeout(removeEmptyHeading, 250);
    setTimeout(removeEmptyHeading, 600);
  });

  const obs = new MutationObserver(removeEmptyHeading);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();